import './MobileModal.scss';
export const MobileModal = ({children, open, showNavBar, fullScreen, title, closeBtn, onClose}) => {
    return (
        <div className={`mobile-modal-component ${open ? 'show': ''} ${showNavBar ? 'navbarshown': ''} ${fullScreen ? 'fullscreen': ''}`}>
            {fullScreen && <div className='modal-header'>
                <i className='icon-one-way' onClick={onClose}></i>
                <b>{title}</b>
                {closeBtn && <button className='outlined icon mid-size' onClick={onClose}>
                    <i className='icon-light-cross'></i>
                </button>}
            </div>}
            {children}
        </div>
    )
}